import { generate } from '../../../core/js/utils/componentUtils';
import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { closeModal } from '../../../core/js/utils/modalUtils';
import { removeHash } from '../../../core/js/utils/routerUtils';
import { popModalTransition } from '../../../core/js/actions/modalActions';

import template from 'modal/afterpay-info-modal.j2';

function firstRender(store) {
    const state = store.getState();
    const data = {
        showLearnMore: true,
        showBackToProduct: _.get(state, 'quickshop.isOpen', false)
    };
    this.render(store, this, data);
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        name: 'modal.afterpay-info',
        replace: 'once',
        firstRender: firstRender,
        template: template,
        afterCloseAction: afterCloseAction
    };
    return generate(config, store, overrides);
}

function afterCloseAction(store) {
    // Remove hash and push state on close
    removeHash();
}

function attachEvents(store) {
    const name = this.name;

    // Close modal on back-button
    bindOnPopStateEvent(this, (e) => {
        closeModal(this, e);
    });

    // Pop modal on "Back to Product" click
    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-back-to-product'), (e) => {
        e.preventDefault();

        const payload = popModalTransition(e, name);

        $.event.trigger({
            type: payload.type,
            payload: payload
        });
    });
}
